{
    "Accessibility": {
        "SvgTitle": {
            "agentIndicator": "Indicador de agente",
            "botIndicator": "Indicador de bot",
            "chatIcon": "Icono de chat",
            "checkboxIcon": "Icono de casilla de verificación",
            "chevronDown": "Chevron hacia abajo",
            "chevronRight": "Chevron hacia la derecha",
            "clockIcon": "Icono de reloj",
            "closeIcon": "Icono de cerrar",
            "endChatIcon": "Icono de finalizar chat",
            "feedbackIcon": "Icono de comentarios",
            "menuIcon": "Icono de menú",
            "muteIcon": "Icono de silenciar",
            "newMessageIcon": "Icono de nuevo mensaje",
            "radioIcon": "Icono de botón de opción",
            "ratingStarIcon": "Icono de estrella de calificación",
            "receiptIcon": "Icono de recibo",
            "ringIcon": "Icono de Ring",
            "sendIcon": "Icono de enviar",
            "themeIcon": "Icono de tema",
            "thumbsDownIcon": "Icono de pulgar hacia abajo",
            "thumbsUpIcon": "Icono de pulgar hacia arriba",
            "unmuteIcon": "Icono de activar sonido",
            "userIcon": "Icono de usuario"
        }
    },
    "Components": {
        "Alert": {
            "ariaLabel": "Cerrar",
            "endChatError": "No se ha podido finalizar la sesión, inténtalo de nuevo.",
            "sessionEnded": "Tu sesión ha finalizado. Te hemos redirigido a la página de inicio.",
            "networkError": "Se ha producido un problema al conectar tu sesión, inténtalo de nuevo.",
            "messageError": "Lo sentimos, nuestro asistente de chat no está disponible en estos momentos. Si necesitas asistencia, visita el <a href='https://ring.com/support'>Centro de ayuda de Ring</a> o inténtalo de nuevo en unos minutos.",
            "messageLabel": "alerta",
            "pendingTimeout": "Lo sentimos, nuestro asistente está tardando más de lo esperado en responder. Por favor, inténtalo de nuevo o reformula tu pregunta."
        },
        "Body": {
            "latestMessage": "Últimos mensajes",
            "loadMessages": "Cargar mensajes",
            "newMessage": "Nuevo mensaje",
            "title": "¿Cómo podemos ayudarte?",
            "subtitle": "¡Hola! Soy el asistente del servicio de Atención al cliente de Ring. ¿Cómo puedo ayudarte?"
        },
        "Bubble": {
            "ariaLabel": "mensaje de chat",
            "eventsTitle": "Eventos recientes",
            "sourceTitle": "Enlaces útiles"
        },
        "Entry": {
            "reasoningAriaLabel": "Pensando",
            "reasonings": {
                "thinkingText": "Pensando"
            }
        },
        "Event": {
            "defaultJoin": "Un miembro del equipo de Ring se ha unido al chat en directo.",
            "customerJoin": "Te hemos transferido al chat en directo.",
            "agentJoin": "se ha unido al chat en directo.",
            "defaultLeft": "El miembro del equipo de Ring ha abandonado el chat en directo.",
            "customerLeft": "Has abandonado el chat.",
            "agentLeft": "ha abandonado el chat en directo.",
            "idle": "Llevas un tiempo inactivo. Avísanos si podemos ayudarte en algo.",
            "idleContinue": "Sigo aquí, pero necesito más tiempo.",
            "idleEnd": "Finalizar chat",
            "returned": "¡Te damos la bienvenida de nuevo! Continuemos con la conversación."
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "Me gusta",
            "ariaLabelThumbsDown": "No me gusta",
            "header": "¿Te ha resultado útil?",
            "sent": "Gracias por tus comentarios.",
            "thumbsDown": "Lamento que mi respuesta no haya sido satisfactoria. Me encantaría conocer tu opinión sobre cómo puedo mejorar.",
            "thumbsDownResponse": "Gracias por tus comentarios. Por favor, prueba a reformular la pregunta.",
            "thumbsUp": "¡Me alegro de que te haya resultado útil! Dime si hay algo más con lo que pueda ayudarte.",
            "RESPONSE_UNCLEAR": "Respuesta poco clara",
            "ISSUE_UNRESOLVED": "No ha solucionado mi problema",
            "NOT_HELPFUL": "No ha sido útil"
        },
        "Footer": {
            "ariaLabel": "Enviar",
            "placeholder": "Haz una pregunta breve…",
            "botText": "Este chatbot utiliza IA generativa para responder a tus preguntas. Verifica la información importante proporcionada en estas respuestas antes de actuar al respecto."
        },
        "Header": {
            "ariaLabelMenu": "Menú más",
            "ariaLabelMinimize": "Minimizar",
            "badgeTitle": "BETA",
            "badgeDisabled": "Desconectado",
            "themeLabel": "Tema",
            "muteLabel": "Silenciar",
            "unmuteLabel": "Desilenciar",
            "feedbackLabel": "Give Feedback",
            "endLabel": "Finalizar chat"
        },
        "NotificationCard": {
            "ariaLabelClose": "Cerrar",
            "ariaLabelOpen": "Abrir",
            "notification": "Nuevo mensaje",
            "expand": "Haz clic para ampliar"
        },
        "WidgetIcon": {
            "ariaLabel": "Chat para soporte"
        },
        "WelcomeScreen": {
            "ariaLabel": "Minimizar",
            "button": "Iniciar chat",
            "title": "Gracias por ponerte en contacto con Ring",
            "subtitleHtml": "Al continuar, aceptas los <a href='https://ring.com/terms'>Términos de servicio de Ring</a>. Es posible que se recopile y registre información relacionada con este chat. Consulta el <a href='https://ring.com/privacy-notice'>Aviso de privacidad</a> para obtener más información.",
            "loading": "Iniciando chat...",
            "error": "No se puede iniciar sesión, inténtalo de nuevo.",
            "messageLabel": "texto de bienvenida"
        }
    }
}